module.exports = __webpack_public_path__ + "static/media/crocodile_ladies_strap_dark_red.8cb0b022.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/crocodile_ladies_strap_dark_red.png
// module id = 121
// module chunks = 0